import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { ReminderSettings } from '../types/domain';

export function settingsEndpoints(http: HttpClient) {
  return {
    getReminders: () => http.get<ApiEnvelope<ReminderSettings>>('/v1/settings/reminders').then(unwrap),
    updateReminders: (body: ReminderSettings) => http.put<ApiEnvelope<ReminderSettings>>('/v1/settings/reminders', body).then(unwrap),
  };
}
export type SettingsEndpoints = ReturnType<typeof settingsEndpoints>;
